<template>
	<div class="resolved-order order-wrap">
		<!--已解决工单-->
		<div class="module-item-style">
			<order-search :orderStatus='filterParams.status'></order-search>
			<el-tabs v-model="activeName">
				<el-tab-pane label="全部" name="all"></el-tab-pane>
			</el-tabs>
			<orderList :filterParams="filterParams" @total="getTotal" @paramsChange="paramsChange"></orderList>
			<pagenations :total="total" :size="filterParams.pageSize" :current-page.sync="filterParams.pageNum" @pageHandler="pageOperate"></pagenations>
		</div>
		<el-dialog
		  :title="orderTitle"
		  :visible.sync="dialogVisible"
		  width="100%"
		  class="orderDetails-wrap"
		  @close="handleClose"
		  :modal="false"
		  >
		  <orderDetails :ticketId='selectTickid' ref="orderDetails"></orderDetails>
		</el-dialog>
	</div>
</template>

<script>
	import pagenations from '@/components/pagenations/pagenations'
	import orderSearch from './components/order-search.vue'
	import orderDetails from './components/order-details.vue'
	import orderList from './components/order-list.vue'
	export default {
		name: 'closed-order',
		components: {
			pagenations,
			orderSearch,
			orderDetails,
			orderList
		},
		data() {
			return {
				isLoading: false,
				dialogVisible:false,
				activeName: 'all',
				tableData: [],
				total: 0,
				selectTickid:'',//给详情组件传的参数
				orderTitle:'',
				filterParams: {
					startCreatTime: '', // 创建时间开始时间
					endCreatTime: '', // 创建时间结束时间
					authorIds: [], // 创建人
					assigneeIds: [], // 处理人,指派客服
					categoryIds: [], // 工单分类
					status: [5], // 工单状态
					ticketTitle: '', // 工单号,标题
					priority: [], // 优先级 0-低，1-中，2-高，3-紧急
					ticketContent: '', // 工单内容
					startResolvedTime: '', // 解决时间开始时间
					endResolvedTime: '', // 解决时间结束时间
					order: 'desc', // 排序，正序还是倒序，asc或者desc
					orderField: 'create_time', // 排序的字段，priority优先级，create_time时间
					pageSize: 10, // 每页数量 默认20
					pageNum: 1, // 页数 默认1
				},
			}
		},
		created() {
			
		},
		mounted() {
			eventBus.$on("getWorkorderDetails", (res) => {
			    // 点击列表显示详情
			    this.selectTickid = res.selectTickid
				this.dialogVisible = true
			    this.orderTitle = res.orderTitle
			});
		},
		methods: {
			/**
			 * 分页操作
			 */
			pageOperate(val) {
				if (val.type == 'currentChange') {
					this.filterParams.pageNum = val.val
				} else if (val.type == "sizeChange") {
					this.filterParams.pageSize = val.val
				}
				this.getOrder()
			},
			// 监听关闭详情时 列表改变
			handleClose(){
				let hasOperate = this.$refs.orderDetails.hasOperate
				if(hasOperate){
					eventBus.$emit('handleOperate',{})
				}
			},
			getTotal(res){
				this.total = res
			},
			paramsChange(params){
				this.filterParams = params
			}
		}
	}
</script>

<style lang="scss">
</style>
